import { useInstance, createRef } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { isNullOrUndefined } from 'intact-shared';
export function useValue() {
  var instance = useInstance();
  var selectedKeys = useState([]);
  var checkedKeys = useState([]);
  var treeRef = createRef();
  instance.watch('value', setKeys);
  function setKeys(v) {
    if (!instance.get('multiple') && !instance.get('checkbox')) {
      v = isNullOrUndefined(v) ? [] : [v];
    } else if (isNullOrUndefined(v)) {
      v = [];
    }
    selectedKeys.set(v);
    checkedKeys.set(v);
  }
  function onChangeCheckedKeys() {
    var keys = getAllCheckedKeys();
    instance.set('value', keys);
    checkedKeys.set(keys);
  }
  function getAllCheckedKeys() {
    // if the parent has been checked, ignore the children
    var keys = [];
    var loop = function loop(nodes) {
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node.checked) {
          keys.push(node.key);
          continue;
        }
        if (node.children) {
          loop(node.children);
        }
      }
    };
    loop(treeRef.value.getNodes());
    return keys;
  }
  function onChangeSelectedKeys(keys) {
    if (instance.get('multiple')) {
      instance.set('value', keys);
    } else {
      instance.set('value', keys[0]);
      instance.hide();
    }
    selectedKeys.set(keys);
  }
  return {
    selectedKeys: selectedKeys,
    checkedKeys: checkedKeys,
    treeRef: treeRef,
    onChangeCheckedKeys: onChangeCheckedKeys,
    onChangeSelectedKeys: onChangeSelectedKeys
  };
}